import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        folders: [],
        accepted_types: [],
        profile: [],
        categories: [],
        sections: [],
        rate: null,
        token: [],
        tokenDecoded: {},
        panelItems: [],
        isNotifications: false,
        notifications: [],
        privileges: [],
        all_privileges: [],
        forms: [],
        userList: [],
        fundingOrg: [],
        bankList: [],
        isAdmin: false,
        submission_file_path: ""
    },
    mutations: {
        SET_NOTIFICATIONS(state, val) {
            state.notifications = val;
        },
        SET_RATE(state, val) {
            state.rate = val;
        },
        ADD_FOLDER(state, val) {
            let folders = state.folders;
            folders.forEach(f => {
                f.active = false;
            });
            folders.push({ ...val, active: true });
            folders.sort(function(a, b) {
                var nameA = a.name.toUpperCase(); // ignore upper and lowercase
                var nameB = b.name.toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }

                // names must be equal
                return 0;
            });
            state.folders = folders;
        },
        SET_CATEGORY(state, val) {
            state.categories = val;
        },
        SET_LOAD(state, val) {
            state.folders = val.folders;
            state.profile = val.user;
            state.panelItems = val.panelItems;
            state.categories = val.categories;
            state.sections = val.sections;
            state.accepted_types = val.accepted_types;
            state.privileges = val.privileges;
            state.all_privileges = val.all_privileges;
            state.forms = val.forms;
            state.submission_file_path = val.submission_file_path;
            // state.userList = val.users.map(item => {
            //     return { name: item.fullname, value: item.id };
            // });
            // state.bankList = val.banks.map(item => {
            //     return {
            //         name: item.name,
            //         value: item.id,
            //         currency: item.currency
            //     };
            // });
            // state.isNotifications = val.enableNotifications;
        },
        SET_TOKEN(state, val) {
            state.token = val;
            if (val == null) {
                state.privileges = [];
                return;
            }
            // try {
            //     state.tokenDecoded = JSON.parse(atob(val.split(".")[1]));
            //     if (state.tokenDecoded.pri.length) {
            //         state.privileges = state.tokenDecoded.pri;
            //         console.log("Privileges: ", state.tokenDecoded.pri);
            //     }
            // } catch (e) {
            //     console.log("error setting token in store");
            // }
        }
    },
    actions: {
        async reloadCategories(context, axios) {
            try {
                const res = await axios.get("/load/categories");
                context.commit("SET_CATEGORY", res.data);
            } catch (e) {
                //
            }
        },
        async loadNotifications(context, axios) {
            if (!context.state.isNotifications) {
                return;
            }
            try {
                let res = await axios.get("/notifications");
                context.commit("SET_NOTIFICATIONS", res.data.data);
            } catch (e) {
                // if (e.response?.data?.error) {
                //     Vue.prototype.swal.fire({
                //         icon: "error",
                //         title: "Error",
                //         text: e.response.data.error
                //     });
                //     return;
                // }
            }
        },
        async loadAPI(context, axios) {
            try {
                let res = await axios.get("/load");
                context.commit("SET_LOAD", res.data);
            } catch (e) {
                console.log(e);
                // if (e.response?.data?.error) {
                //     Vue.prototype.swal.fire({
                //         icon: "error",
                //         title: "Error",
                //         text: e.response.data.error
                //     });
                //     return;
                // }
            }
        },
        setToken(context, token) {
            context.commit("SET_TOKEN", token);
        }
    },
    getters: {
        unreadNotifications: state =>
            state.notifications.filter(item => !item.is_read).length,
        parentCategories: state =>
            state.categories.filter(item => item.parent_id == null),
        leafCategories: state =>
            state.categories.filter(item => item.parent_id != null)
    }
});

export default store;
